import { render, staticRenderFns } from "./Directorships.vue?vue&type=template&id=44e61e52&"
import script from "./Directorships.vue?vue&type=script&lang=js&"
export * from "./Directorships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports